"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var Components_1 = require("./Components");
require("./Styles/Organisation.css");
var OrganisationStatus;
(function (OrganisationStatus) {
    OrganisationStatus[OrganisationStatus["Registering"] = 0] = "Registering";
    OrganisationStatus[OrganisationStatus["Registered"] = 1] = "Registered";
})(OrganisationStatus || (OrganisationStatus = {}));
var Organisation = /** @class */ (function (_super) {
    __extends(Organisation, _super);
    function Organisation(props) {
        var _this = _super.call(this, props) || this;
        _this.getValueFromRef = function (ref) { return ref.current ? ref.current.value.trim() : ""; };
        _this.getNameFromRef = function (ref) { return ref.current ? ref.current.name : ""; };
        _this.state = {
            Status: OrganisationStatus.Registering
        };
        return _this;
    }
    Organisation.prototype.render = function () {
        var _this = this;
        var _a, _b;
        return (React.createElement(reactstrap_1.Row, { className: "mx-0 tfa-row" },
            React.createElement(reactstrap_1.Col, { xs: "3" }),
            React.createElement(reactstrap_1.Col, { xs: "3" },
                React.createElement(reactstrap_1.Row, null,
                    React.createElement("img", { src: this.props.siteLogo, alt: "VeriLite" })),
                React.createElement(reactstrap_1.Row, null,
                    React.createElement("img", { src: this.props.companyLogo, alt: "Solidsoft Reply" }))),
            React.createElement(reactstrap_1.Col, { xs: "4" },
                React.createElement(reactstrap_1.Card, { inverse: true, color: "primary", className: "border-none organisation-registration-card" },
                    React.createElement(reactstrap_1.CardBody, null, this.state.Status === OrganisationStatus.Registering ?
                        React.createElement("div", null,
                            React.createElement(reactstrap_1.CardTitle, { tag: "h3" }, (_a = this.props.resources) === null || _a === void 0 ? void 0 : _a.Registration_RegisterOrganisationHeading),
                            React.createElement(Components_1.OrganisationRegistrationForm, { resources: this.props.resources, onRegisterComplete: function () { return _this.setState({ Status: OrganisationStatus.Registered }); } }))
                        :
                            React.createElement("div", null,
                                React.createElement(reactstrap_1.CardTitle, { tag: "h3" }, (_b = this.props.resources) === null || _b === void 0 ? void 0 : _b.Registration_OrganisationRegistered),
                                React.createElement(Components_1.PostRegistrationForm, { resources: this.props.resources }))))),
            React.createElement(reactstrap_1.Col, { xs: "2" })));
    };
    return Organisation;
}(React.Component));
exports.Organisation = Organisation;
//# sourceMappingURL=Organisation.js.map